module.exports = __webpack_public_path__ + "static/media/Level_1.b3042d98.png";